import React from "react";

const FireIcon = () => {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.87359 6.3807L1.87201 6.38229L1.86884 6.38466L1.86092 6.391C1.82657 6.41707 1.79329 6.44454 1.76118 6.47333C1.67829 6.54674 1.59853 6.6236 1.52209 6.7037C1.33209 6.90399 1.08826 7.20166 0.859467 7.59987C0.398717 8.40341 0.0115918 9.6012 0.2293 11.2027C0.443842 12.7837 1.10805 14.105 2.23063 15.0265C3.35005 15.9448 4.8653 16.4167 6.69801 16.4167C8.58772 16.4167 10.0966 15.7081 11.0949 14.4929C12.0845 13.2888 12.5263 11.6461 12.421 9.85058C12.3196 8.12791 11.3815 6.82087 10.5526 5.66662L10.3159 5.33649C9.41184 4.06033 8.69855 2.8847 8.87192 1.23962C8.88069 1.15682 8.87195 1.07311 8.84627 0.99391C8.82058 0.914711 8.77853 0.8418 8.72283 0.77991C8.66714 0.71802 8.59905 0.668535 8.52299 0.634668C8.44693 0.600801 8.3646 0.583309 8.28134 0.583328C7.97892 0.583328 7.63217 0.676745 7.29809 0.817662C6.91123 0.983523 6.54619 1.19622 6.21113 1.45099C5.47884 2.00358 4.74655 2.83641 4.35626 3.94949C3.96676 5.05941 4.16467 6.11708 4.44968 6.88737C4.6373 7.39324 4.43384 7.89279 4.12747 8.03845C3.99711 8.10012 3.84796 8.10902 3.71119 8.06328C3.57442 8.01755 3.46063 7.92072 3.39359 7.79304L2.75551 6.58099C2.71557 6.50496 2.65962 6.43849 2.5915 6.38618C2.52339 6.33387 2.44473 6.29695 2.36097 6.27799C2.2772 6.25902 2.19032 6.25845 2.10631 6.27632C2.02231 6.29419 1.94318 6.33008 1.87438 6.38149"
        fill="#EE6352"
      />
    </svg>
  );
};

export default FireIcon;
